<template>
  <div class="popup" v-cloak v-if="createShow">
    <div class="content" id="googlePhotosV2Tips">
      <div class="title">
        <span>{{$t('language.cloudExploer.newFolder')}}</span>
        <div class="icon white-close dialog-close" @click="createShow = false"></div>
      </div>
      <div class="create-content">
        <input type="text" v-model="folderName" maxlength="50" ref="folderInput" v-focus
          :placeholder="$t('language.popup.cloudExploerPopup.googlePhotosV2FolderNameInput')" />
        <button @click="okDeal()">{{$t('language.common.ok')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items"],
  data: function () {
    return {
      createShow: false,
      folderName: '',
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  },
  methods: {
    okDeal() {
      if (this.folderName.trim().length === 0) {
        this.$toast({
          text: 'Please enter the folder name',
          type: 'fail',
          idValue: 'rightContBan',
          learnMoreShow: false
        });
        return
      }

      // 非法字符正则（Windows 文件夹名非法字符）
      const invalidChars = /[\\/:*?"<>|]/;
      if (invalidChars.test(this.folderName.trim())) {
        this.$toast({
          text: 'Folder name cannot contain special characters: \\ / : * ? " < > |',
          type: 'fail',
          idValue: 'rightContBan',
          learnMoreShow: false
        });
        return
      }

      // 重名检查（忽略大小写可选）
      if (this.items) {
        const nameExists = this.items.some(item => item.name === this.folderName.trim())
        if (nameExists) {
          this.$toast({
            text: 'A folder with this name already exists',
            type: 'fail',
            idValue: 'rightContBan',
            learnMoreShow: false
          });
          return
        }
      }

      this.$emit('createFolder', this.folderName.trim())
      this.folderName = ''
      this.createShow = false
    },
  }
}
</script>

<style scoped>
#googlePhotosV2Tips {
  width: 768px;
  height: 130px;
}

.create-content {
  padding: 20px;
}

.create-content>input {
  width: 600px;
}

.create-content>button {
  margin-left: 20px;
  width: 100px;
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/google_photos_v2_create_popup.vue